import actionTypes from '../constants/action-types';

const deletePage = (pageId, languageCodes) => ({
  type: actionTypes.DELETE_PAGE,
  payload: {
    pageId,
    languageCodes,
  },
});

export default deletePage;
